/**
 * Welcome modal shown when an in-training external agent first lands on
 * `/properties` (MRG-281). Matches the Figma node 5:14 / 52:219 design:
 * centered card, "Welcome to Orchard Offers" + "Show me around" CTA.
 */

import { Button } from '@/common/components/button'
import { Dialog } from '@/common/components/dialog'

import * as styles from './WelcomeModal.css'

export interface WelcomeModalProps {
  open: boolean
  onContinue: () => void
}

export function WelcomeModal({ open, onContinue }: WelcomeModalProps) {
  return (
    <Dialog open={open}>
      <Dialog.Content width={463} showOverlay data-testid="agent-training-welcome">
        <div className={styles.card}>
          <Dialog.Title className={styles.title}>Welcome to Orchard Offers</Dialog.Title>
          <Dialog.Description className={styles.body}>
            We&rsquo;ll give you a quick tour so you know how to submit your first property.
          </Dialog.Description>
          <div className={styles.buttonRow}>
            <Button variant="primary" onClick={onContinue}>
              Show me around
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
